import { faFilter as farFaFilter } from '@fortawesome/pro-regular-svg-icons';
import { faFilter as fasFaFilter } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import React, { FCC } from 'react';
import { FilterModal } from '../Filter';
import { Icon } from '../Icon';
import './GridFilter.scss';
import { IGridFilterProps } from './types';

export const GridFilter: FCC<IGridFilterProps> = (props) => {
  return (
    <div className="hlc-datagrid-filter-controls">
      <FilterModal
        filters={props.filters}
        initialValues={props.initialValues}
        onChange={props.onChange}
        setIsFiltering={props.setIsFiltering}
        render={({ openFilterModal, isFiltering }) => {
          const filterClasses = classNames('hlc-datagrid-filter-icon', {
            filtering: isFiltering,
          });
          return (
            <span className={`fa-fw ${filterClasses}`}>
              {isFiltering ? (
                <Icon
                  qa-id={props['qa-id']}
                  title="Filter On"
                  icon={fasFaFilter}
                  size={'lg'}
                  onClick={openFilterModal}
                />
              ) : (
                <Icon qa-id={props['qa-id']} title="Filter" icon={farFaFilter} size={'lg'} onClick={openFilterModal} />
              )}
            </span>
          );
        }}
      />
    </div>
  );
};

export default GridFilter;
